import { LandingPageUrl } from '@dev/ee-api/ee-api-models';
import { Action } from 'redux';
export enum ActionTypes {
    GET_LANDING_PAGE_SUBDOMAIN = '@@landing/GET_SUBDOMAIN',
    ADD_LANDING_PAGE_SUBDOMAIN = '@@landing/ADD_SUBDOMAIN',
    UPDATE_LANDING_PAGE_SUBDOMAIN = '@@landing/UPDATE_SUBDOMAIN',
    ADD_LANDING_PAGE_TO_ACCOUNT_SUBDOMAIN = '@@landing/ADD_SUBDOMAIN_TO_ACCOUNT',
    UPDATE_LANDING_PAGE_TO_ACCOUNT_SUBDOMAIN = '@@landing/UPDATE_SUBDOMAIN_TO_ACCOUNT',
    LANDING_PAGE_SUBDOMAIN_ERROR = '@@landing/ERROR',
    LANDING_PAGE_SUBDOMAIN_SUCCESS = '@@landing/ADD_SUBDOMAIN_SUCCESS',
    LANDING_PAGE_SKIP_SUBDOMAIN_LOADING = '@@landing/SKIP_SUBDOMAIN_LOADING',
}

export interface LoadLandingPageSubdomainAction extends Action {
    type: ActionTypes.GET_LANDING_PAGE_SUBDOMAIN;
    payload: {
        landingPageId: number;
    };
}

export interface AddLandingPageSubdomainAction extends Action {
    type: ActionTypes.ADD_LANDING_PAGE_SUBDOMAIN;
    payload: LandingPageUrl;
    meta: {
        thunk: boolean;
    };
}

export interface UpdateLandingPageSubdomainAction extends Action {
    type: ActionTypes.UPDATE_LANDING_PAGE_SUBDOMAIN;
    payload: LandingPageUrl;
    meta: {
        thunk: boolean;
    };
}
export interface AddLandingPageAccountSubdomainAction extends Action {
    type: ActionTypes.ADD_LANDING_PAGE_TO_ACCOUNT_SUBDOMAIN;
    payload: string;
    meta: {
        thunk: boolean;
    };
}

export interface UpdateLandingPageAccountSubdomainAction extends Action {
    type: ActionTypes.UPDATE_LANDING_PAGE_TO_ACCOUNT_SUBDOMAIN;
    payload: string;
    meta: {
        thunk: boolean;
    };
}

export interface LandingPageSubdomainError extends Action {
    type: ActionTypes.LANDING_PAGE_SUBDOMAIN_ERROR;
    payload: {
        errorKey: string;
    };
    meta: Record<string, unknown>;
    error: boolean;
}

export interface LandingPageSkipSubdomainLoading extends Action {
    type: ActionTypes.LANDING_PAGE_SKIP_SUBDOMAIN_LOADING;
}

export interface LandingPageSubdomainSuccess extends Action {
    type: ActionTypes.LANDING_PAGE_SUBDOMAIN_SUCCESS;
    payload: {
        subdomain: LandingPageSubdomainModel;
    };
    meta: Record<string, unknown>;
}

export interface LandingPageSubdomain {
    loading: boolean;
    accountSubdomain: string;
    landingPageSubdomain: LandingPageSubdomainModel;
}

/**
 *
 */
export interface LandingPageSubdomainModel {
    LandingPageID: number;
    UrlPrefix: string;
    UrlSuffix: string;
    DateAdded?: string;
}
